/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import BigPlayIcon from '../../assets/icons/BigPlayIcon'
import { getUniqueKey } from '../../utils/HTMLutils'
import VideoPlayer, { VideoPlayerProps } from '../videoPlayer/VideoPlayer'
import './PreviaVideo.scss'
const rootClassName = 'previa-video'

interface PreviaVideoProps {
  imgUrl: string
  urlVideo?: string
  label?: string
  videoPlayerProps?: VideoPlayerProps
}

function PreviaVideo(props: PreviaVideoProps) {
  const [id] = useState(getUniqueKey())
  const [clicou, setClicou] = useState(false)

  let firstHeight = useRef<any>()

  useLayoutEffect(() => {
    const el = document.querySelector(`#${id}`) as HTMLElement
    const resiz = () => {
      el.style.height = `${el.getBoundingClientRect().width * 0.5625}px`
    }
    if (clicou) {
      firstHeight.current = `${el.getBoundingClientRect().height}px`
      el.style.height = firstHeight.current
      setTimeout(resiz, 5)
      window.addEventListener('resize', resiz)
    }

    return () => {
      window.removeEventListener('resize', resiz)
    }
  }, [clicou])

  const videoPlayerProps = useMemo(() => {
    return {
      ...props.videoPlayerProps,
      callBackStopped: (id?: string) => {
        if (typeof props.videoPlayerProps?.callBackStopped === 'function') {
          props.videoPlayerProps.callBackStopped(id!)
        }
        setClicou(false)
      }
    }
  }, [props.videoPlayerProps])

  return (
    <div
      id={id}
      className={rootClassName}
      onClick={() => {
        if (!clicou) setClicou(true)
      }}
    >
      <div
        className={`${rootClassName}-img`}
        style={{ backgroundImage: `url(${props.imgUrl})` }}
      ></div>
      <div className={`${rootClassName}-icon`}>
        <BigPlayIcon hideBackground />
      </div>
      <div className={`${rootClassName}-label`}>{props.label}</div>
      <CSSTransition
        in={clicou}
        timeout={300}
        mountOnEnter
        unmountOnExit
        classNames='video'
        onExiting={() => {
          const el = document.querySelector(`#${id}`) as HTMLElement
          el.style.height = firstHeight.current
        }}
      >
        <div className={`${rootClassName}-video`}>
          <VideoPlayer blackGround {...videoPlayerProps} url={props.urlVideo} />
        </div>
      </CSSTransition>
    </div>
  )
}

export default memo(PreviaVideo)
